// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sop[data-v-3c28aa9a] {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.sop[data-v-3c28aa9a] .el-tabs {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n}\n.sop[data-v-3c28aa9a] .el-tabs .el-tabs__content {\n      flex: 1;\n}\n.sop[data-v-3c28aa9a] .el-tabs .el-tabs__content .el-tab-pane {\n        height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
